import {
  CustomsCityAbiGridPayload,
  CustomsCityDraftGridPayload,
  FullmanFileSearchDataPayload,
} from '../fullman-upload.model';

export class FetchFullmanFileData {
  static readonly type = '[Fullman Upload] Fullman File Data';
  constructor(public payload: FullmanFileSearchDataPayload) {}
}

export class ResetFullmanFileList {
  static readonly type = '[Fullman Upload] Reset Fullman Upload List';
}

export class FetchCustomsCityDraftData {
  static readonly type = '[Customs City Draft] Fetch Draft Grid Data';
  constructor(public payload: CustomsCityDraftGridPayload) {}
}

export class ResetCustomsCityDraftList {
  static readonly type = '[Customs City Draft] Reset Draft Grid List';
}

export class FetchCustomsCityAbiData {
  static readonly type = '[Customs City ABI] Fetch ABI Grid Data';
  constructor(public payload: CustomsCityAbiGridPayload) {}
}

export class ResetCustomsCityAbiList {
  static readonly type = '[Customs City ABI] Reset ABI Grid List';
}

/* LEGACY CBP — rollback: uncomment and re-register CbpRequestState / CbpResponseState in store.module.ts
export class FetchCbpRequestStatusData { ... }
export class ResetCbpRequestList { ... }
export class FetchCbpResponseStatusData { ... }
export class ResetCbpResponseList { ... }
*/
